import React from "react";
import { Card, Button, Row, Col } from "antd";
import "../styles/MappingComplete.module.scss";
import { Icon } from "Components";
import { TenantMapping } from "../Mapping";

interface MappingCompleteProps {
  tenantInfo: TenantMapping;
  mappingCount?: number;
  onBackToHome: () => void;
}

export const MappingComplete: React.FC<MappingCompleteProps> = ({
  tenantInfo,
  mappingCount,
  onBackToHome,
}) => {
  return (
    <div className="mappingCompleteWrapper">
      <Card bordered={false} className="mappingCompleteCard">

        {/* Header */}
        <div className="mappingCompleteHeader">
          <div className="mappingIconWrapper">
           <Icon type="mappingComplete" />
          </div>
          <h2 className="mappingCompleteTitle">Mapping Successful</h2>
          <p className="mappingCompleteSubtitle">
            The property mapping has been saved to your client profile
          </p>
        </div>

        {/* Content */}
        <div className="mappingCompleteContent">
          <Row justify="space-between" className="mappingRow">
            <Col className="mappingLabel">Client:</Col>
            <Col className="mappingValue">{tenantInfo.name}</Col>
          </Row>
          <Row justify="space-between" className="mappingRow">
            <Col className="mappingLabel">Properties Mapped:</Col>
            <Col className="mappingValue">{mappingCount}</Col>
          </Row>
          <Row justify="space-between" className="mappingRow">
            <Col className="mappingLabel">Status:</Col>
            <Col className="mappingStatus">Active</Col>
          </Row>
        </div>

        {/* Description */}
        <p className="mappingCompleteDescription">
          The mapping is now updated. Updated data will be available in the dashboard within 24 hours.
        </p>

        {/* Button */}
        <div className="mappingCompleteButtonWrapper">
          <Button className="mappingCompleteButton" type="primary" onClick={onBackToHome}>
            Back to Mapping Settings
          </Button>
        </div>
      </Card>
    </div>

  );
};
